import { useTheme } from '@mui/material/styles';
import { BarChart } from '@mui/x-charts';
import { ChartFrame } from './ChartFrame';
import { calendarTick, type BarChartProps } from './chartTypes';

export const MUIBarChart = ({
  data,
  dataKey = 'name',
  valueKey = 'value',
  horizontal = false,
  showGrid = true,
  ...frame
}: BarChartProps) => {
  const theme = useTheme();
  const categories = { scaleType: 'band' as const, dataKey, valueFormatter: calendarTick };
  const values = { scaleType: 'linear' as const, min: 0, tickMinStep: 1 };
  return (
    <ChartFrame {...frame} hasData={data.length > 0}>
      <BarChart
        height={frame.height || 300}
        dataset={data.map((item) => ({ [dataKey]: item.name, [valueKey]: item.value }))}
        xAxis={[horizontal ? values : categories]}
        yAxis={[horizontal ? categories : values]}
        series={[{ dataKey: valueKey, label: frame.title || 'Value', color: theme.palette.status.settled }]}
        layout={horizontal ? 'horizontal' : 'vertical'}
        grid={{ horizontal: showGrid }}
        hideLegend
        margin={{ left: horizontal ? 80 : 48, right: 12, top: 12, bottom: 40 }}
      />
    </ChartFrame>
  );
};
